/* istanbul ignore file */
import React from 'react';
import { EnumDropdown, DefaultInputPropTypes } from 'framework/form';
import { PURCHASE_ORDER_TYPES_OPTIONS } from 'domain/finance/purchaseOrder/usePurchaseOrderService';

const PurchaseOrderTypeDropdown = (props: DefaultInputPropTypes<string>) => {
  return <EnumDropdown options={PURCHASE_ORDER_TYPES_OPTIONS} label="Type" placeholder="Select type" {...props} />;
};

export default PurchaseOrderTypeDropdown;
